const videosSelector = '.video-play'

const initVideo = () => {
  const videos = document.querySelectorAll('.video-play')
  videos.forEach(button => {
    const btnToggleClass = 'video__play-btn--hidden'
    const posterToggleClass = 'video__img--hidden'
    const poster = document.querySelector(button.getAttribute('data-poster'))

    const type = button.dataset.type
    const iframe = document.querySelector(button.getAttribute('data-video'))
    if (!iframe) return

    const src = iframe.getAttribute('data-iframe-src') ? iframe.getAttribute('data-iframe-src') : iframe.src
    const url = new URL(src)

    const onYoutubeClick = e => {
      e.preventDefault()
      // const isPlaying = url.searchParams.get('autoplay') === 1;

      url.searchParams.set('autoplay', 1)
      button.classList.add(btnToggleClass)
      iframe.setAttribute('src', url.href)

      if (poster) {
        poster.classList.add(posterToggleClass)
      }

      button.removeEventListener('click', onYoutubeClick)
    }
    button.addEventListener('click', onYoutubeClick)
  })
}

export { videosSelector, initVideo }
